<template>
  <!-- 审批、详情时，审批流展示 -->
  <div class="content">
    <ul class="flow-wrapper" v-if="dataList.length>0">
      <li class="flow-item" v-for="(item, index) in dataList" v-bind:key="index">
        <!-- 左侧直线 -->
        <div
          class="flow-item-line"
          v-if="item.ApprovalMemberList.length> 0 || item.ApprovalCCMemberList.length>0"
        ></div>
        <!-- 发起人 -->
        <div class="flow-item-header" v-if="item.ApprovalFlowNodeName === '发起人'">
          <div class="flow-avatar" v-if="item.ApprovalMemberList[0].Icon && item.ApprovalMemberList[0].Icon !== ''"   :style="{background:'url('+ imgUrl +item.ApprovalMemberList[0].Icon+')' + '0/cover'}">
            <span v-if="item.ApprovalMemberList[0].Icon && item.ApprovalMemberList[0].Icon !== ''" ></span>
          </div>
           <div class="flow-avatar" v-if="item.ApprovalMemberList[0].Icon=== ''" >
            <span v-if="item.ApprovalMemberList[0].Icon=== ''"  v-bind:title="item.ApprovalMemberList[0].FullName" >{{ showName(item.ApprovalMemberList[0].FullName) }}</span>
          </div>
        </div>
        <div
          class="flow-item-content"
          v-bind:class="{hasCC:item.ApprovalCCMemberList.length > 0}"
          v-if="item.ApprovalFlowNodeName === '发起人'"
        >
          <div class="flow-content-header">
            <div class="flow-content-title">{{ item.ApprovalMemberList[0].FullName }}</div>
            <div
              class="flow-content-time"
            >{{ xyFormatDate(item.ApprovalMemberList[0].ApprovalDate) }}</div>
          </div>
          <div class="flow-content-body">
            <div class="flow-content-reason">发起申请</div>
          </div>
        </div>
        <!-- 只有一人 -->
        <div
          class="flow-item-header"
          v-if="item.ApprovalFlowNodeName !== '发起人' && item.ApprovalMemberList.length === 1"
        >
          <div
            class="flow-avatar flow-status-icon" v-if="item.ApprovalMemberList[0].Icon && item.ApprovalMemberList[0].Icon !== ''"  :style="{background:'url('+ imgUrl + item.ApprovalMemberList[0].Icon+')' + '0/cover'}"
            v-bind:class="{'flow-status-icon-pass': item.Status === '已通过','flow-status-icon-processing': item.Status === '待审批' && index === dataList.currentAuditNodeIndex, 'flow-status-icon-reject': item.Status === '已拒绝'}"
          >
          </div>
          <div v-if="item.ApprovalMemberList[0].Icon === ''" 
            class="flow-avatar flow-status-icon"
            v-bind:class="{'flow-status-icon-pass': item.Status === '已通过','flow-status-icon-processing': item.Status === '待审批' && index === dataList.currentAuditNodeIndex, 'flow-status-icon-reject': item.Status === '已拒绝'}"
          >
            <span v-bind:title="item.ApprovalMemberList[0].FullName" >{{ showName(item.ApprovalMemberList[0].FullName) }}</span>
          </div>
        </div>
        <div
          class="flow-item-content"
          v-bind:class="{hasCC:item.ApprovalCCMemberList.length > 0}"
          v-if="item.ApprovalFlowNodeName !== '发起人' && item.ApprovalMemberList.length === 1"
        >
          <div class="flow-content-header">
            <div class="flow-content-title">
              {{ item.ApprovalMemberList[0].FullName }}
              <span
                v-show="item.isFinished || (item.Status === '待审批' && index === dataList.currentAuditNodeIndex)"
              >({{ item.Status }})</span>
            </div>
            <div
              class="flow-content-time"
            >{{ xyFormatDate(item.ApprovalMemberList[0].ApprovalDate) }}</div>
          </div>
          <div class="flow-content-body">
            <div class="flow-content-reason">{{ item.ApprovalMemberList[0].Option }}</div>
          </div>
        </div>
        <!-- 多人审批（会签、或签） -->
        <div class="flow-item-header" v-if="item.ApprovalMemberList.length > 1">
          <div
            class="flow-avatar flow-status-icon"
            v-bind:class="{'flow-status-icon-pass': item.Status === '已通过','flow-status-icon-processing': item.Status === '待审批'  && index === dataList.currentAuditNodeIndex, 'flow-status-icon-reject': item.Status === '已拒绝'}"
          >{{ showName(item.ApprovalFlowNodeName) }}</div>
        </div>
        <div
          class="flow-item-content"
          v-bind:class="{hasCC:item.ApprovalCCMemberList.length > 0}"
          v-if="item.ApprovalMemberList.length > 1"
        >
          <div class="flow-content-header">
            <div class="flow-content-title">
              {{ item.ApprovalFlowNodeName }} {{
              item.ApprovalMemberList.length }} 人
              <span
                v-show="item.isFinished || (item.Status === '待审批' && index === dataList.currentAuditNodeIndex)"
              >({{ item.Status }})</span>
            </div>
            <a
              v-if="item.isOverviewMode"
              href="javascript:;"
              class="flow-content-btn--showDetail"
              @click="setStatus_isOverviewMode(item, index, 'normal', false)"
            >展开<span class="cssIcon-triangle cssIcon-triangle--t2b"></span>
            </a>
            <a
              v-else
              href="javascript:;"
              class="flow-content-btn--hideDetail"
              @click="setStatus_isOverviewMode(item, index, 'normal', true)"
            >
              收起
              <span class="cssIcon-triangle cssIcon-triangle--b2t"></span>
            </a>
          </div>
          <!-- 多人：默认的缩略预览模式 -->
          <div v-if="item.isOverviewMode" class="flow-overview-body">
            <ul class="flow-overview-list">
              <li
                class="flow-overview-item"
                v-for="(member,memberIndex) in item.overviewList"
                :key="memberIndex"
              >
                <div
                  class="flow-avatar flow-avatar--small flow-status-bgcolor"
                  v-bind:class="{'flow-status-bgcolor-pass': member.Status === '已通过','flow-status-bgcolor-processing': member.Status === '待审批' && index === dataList.currentAuditNodeIndex, 'flow-status-bgcolor-reject': member.Status === '已拒绝'}"
                  v-bind:key="memberIndex"
                >
                  <div v-if="member.Icon && member.Icon !== ''" class="flow-avatar-imgWrapper" :style="{background:'url('+ imgUrl + member.Icon+')' + '0/cover'}"></div>
                  <span v-else v-bind:title="member.FullName">{{ showName(member.FullName) }}</span>
                </div>
                <p class="flow-overview-name">{{member.FullName}}</p>
              </li>
              <li class="flow-overview-item" v-if="item.ApprovalMemberList.length > 5">
                <div class="flow-avatar flow-avatar--small">
                  <span class="flow-avatar-ellipsis">...</span>
                </div>
              </li>
            </ul>
            <!-- 发生审批结论时 -->
            <div class="flow-content-time" v-show="item.IsComplete">{{xyFormatDate(item.lastComplete_time)}}</div>
          </div>
          <!-- 多人：展开详情 -->
          <div v-else class="flow-content-body">
            <ul class="flow-detail-list">
              <li
                class="flow-detail-item"
                v-for="(member,memberIndex) in item.ApprovalMemberList"
                :key="memberIndex"
              >
                <div
                  class="flow-avatar flow-avatar--small flow-status-bgcolor"
                  v-bind:class="{'flow-status-bgcolor-pass': member.Status === '已通过','flow-status-bgcolor-processing': member.Status === '待审批' && index === dataList.currentAuditNodeIndex, 'flow-status-bgcolor-reject': member.Status === '已拒绝'}"
                  v-bind:key="memberIndex"
                >
                  <div v-if="member.Icon && member.Icon !== ''" class="flow-avatar-imgWrapper" :style="{background:'url('+ imgUrl + member.Icon+')' + '0/cover'}"></div>
                  <span v-else v-bind:title="member.FullName">{{ showName(member.FullName) }}</span>
                </div>
                <div class="flow-detail-wrapper">
                  <div class="flow-detail-header">
                    <div class="flow-content-name">{{member.FullName}}</div>
                    <div class="flow-content-time">{{xyFormatDate(member.ApprovalDate)}}</div>
                  </div>
                  <div class="flow-detail-body">
                    <div class="flow-content-reason">{{member.Option}}</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 抄送 -->
        <div class="flow-item-header flow-CC" v-if="item.ApprovalCCMemberList.length > 0">
          <span class="flow-icon-radio"></span>
        </div>
        <div class="flow-item-content flow-CC" v-if="item.ApprovalCCMemberList.length > 0">
          <div class="flow-content-header">
            <div class="flow-content-title">抄送 {{ item.ApprovalCCMemberList.length }} 人</div>
            <a
              v-if="item.isOverviewMode_CC"
              href="javascript:;"
              class="flow-content-btn--showDetail"
              @click="setStatus_isOverviewMode(item, index, 'CC', false)"
            >
              展开
              <span class="cssIcon-triangle cssIcon-triangle--t2b"></span>
            </a>
            <a
              v-else
              href="javascript:;"
              class="flow-content-btn--hideDetail"
              @click="setStatus_isOverviewMode(item, index, 'CC', true)"
            >
              收起
              <span class="cssIcon-triangle cssIcon-triangle--b2t"></span>
            </a>
          </div>
          <!-- 抄送：默认的缩略预览模式 -->
          <div v-if="item.isOverviewMode_CC" class="flow-overview-body">
            <ul class="flow-overview-list">
              <li
                class="flow-overview-item"
                v-for="(member,memberIndex) in item.overviewList_CC"
                v-bind:key="memberIndex"
              >
                <div class="flow-avatar flow-avatar--small">
                  <div v-if="member.Icon && member.Icon !== ''" class="flow-avatar-imgWrapper" :style="{background:'url('+ imgUrl +member.Icon+')' + '0/cover'}"></div>
                  <span v-else v-bind:title="member.FullName">{{ showName(member.FullName) }}</span>
                </div>
                <p class="flow-overview-name">{{member.FullName}}</p>
              </li>
              <li class="flow-overview-item" v-if="item.ApprovalCCMemberList.length > 5">
                <div class="flow-avatar flow-avatar--small">
                  <span class="flow-avatar-ellipsis">...</span>
                </div>
              </li>
            </ul>
          </div>
          <!-- 抄送：展开详情 -->
          <div v-else class="flow-content-body">
            <ul class="flow-detail-list">
              <li
                class="flow-detail-item"
                v-for="(member,memberIndex) in item.ApprovalCCMemberList"
                :key="memberIndex"
              >
                <div class="flow-avatar flow-avatar--small flow-status-bgcolor">
                  <div v-if="member.Icon && member.Icon !== ''" class="flow-avatar-imgWrapper" :style="{background:'url('+ imgUrl +member.Icon+')' + '0/cover'}"></div>
                  <span v-else v-bind:title="member.FullName">{{ showName(member.FullName) }}</span>
                </div>
                <div class="flow-detail-wrapper">
                  <div class="flow-detail-header">
                    <div class="flow-content-name">{{member.FullName}}</div>
                  </div>
                  <div class="flow-detail-body"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "ApprovalFlow",
  props: {
    dataList: {
      type: Array
    }
  },
  components: {},
  data() {
    return {
      imgUrl: this.xyMApi + '/base',
      isBack: false
    };
  },
  created() {
    // 是否是选择抄送人回来的
  },
  methods: {
    showName(name) {
      // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
      if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
        return name.length > 2 || name.length === 3 ? name.slice(-2) : name;
      } else if (/^[A-Za-z]+$/g.test(name)) {
        // 纯英文名只展示两个字母
        return name.slice(0, 2);
      } else {
        // 其他
        return name.slice(0, 2);
      }
    },
    xyFormatDate(date, format = "MM.DD HH:mm") {
      return date ? this.xy.moment(date).format(format) : "";
    },
    // 展开或折叠
    setStatus_isOverviewMode: function(item, index, type, value) {
      if (type === "normal") {
        item.isOverviewMode = value;
      } else if (type === "CC") {
        item.isOverviewMode_CC = value;
      } else {
        item.isOverviewMode = value;
      }
      this.$set(this.dataList, index, item);
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  padding-bottom: 30px;
}
.flow-wrapper {
  position: relative;
  z-index: 0;
  margin-bottom: 100px;
}
.flow-item {
  position: relative;
  margin: 0;
  padding: 0 0 40px;
}
.flow-item-line {
  height: 100%;
  border-left: 2px solid #c6c6c6;
  position: absolute;
  left: 28px;
  top: 0;
}
.flow-item-header {
  width: 60px;
  height: 60px;
  background-color: #4196ff;
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  color: #fff;
}
.flow-item-content {
  min-height: 60px;
  padding: 1px 1px 50px 85px;
  font-size: 14px;
  position: relative;
  top: -3px;
}
.flow-item-content.hasCC:not(.flow-CC)::after {
  content: "";
  height: 100%;
  border-left: 2px solid #c6c6c6;
  position: absolute;
  z-index: 0;
  left: 28px;
  top: 3px;
}
.flow-item:last-child .flow-item-line {
  display: none;
}
.flow-avatar {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  line-height: 60px;
  background: #4196ff;
  border-radius: 50%;
  font-size: 28px;
  text-align: center;
  color: #fff;
}
.flow-avatar span {
  color: #fff;
  font-size: 24px;
}
.flow-avatar img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.flow-avatar-imgWrapper {
  width: 55px;
  height: 55px;
  // overflow: hidden;
  border-radius: 50%;
}
.flow-item-header .flow-avatar span{
  width: 60px;
  height: 60px;
  // overflow: hidden;
  border-radius: 50%;
}
.flow-avatar--small {
  position: relative;
  width: 55px;
  height: 55px;
  margin: 0 auto;
  line-height: 55px;
  font-size: 24px;
}
.flow-avatar-ellipsis {
  position: absolute;
  top: -13%;
  left: 26%;
  font-size: 28px;
}
.flow-avatar-iconWrapper {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
}
.flow-avatar > span {
  display: inline-block;
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
  letter-spacing: 1px;
}
.flow-content-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  color: #666;
}
.flow-content-btn--hideDetail {
  color: #4196ff;
  font-size: 28px;
}
.flow-content-btn--showDetail {
  color: #666;
  font-size: 28px;
}
.flow-content-body {
  min-height: 1em;
}
.flow-content-name {
  color: #161616;
  font-size: 24px;
}
.flow-content-reason {
  color: #999;
  font-size: 24px;
}
.flow-content-title {
  font-size: 28px;
  color: #161616;
}
.flow-content-time {
  color: #999;
  font-size: 24px;
}
.flow-detail-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 40px;
}
.flow-detail-wrapper {
  width: 100%;
  margin-left: 20px;
  padding: 5px 0 5px 0;
}
.flow-detail-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.flow-overview-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.flow-overview-item {
  margin-top: 6px;
  margin-right: 10px;
}
.flow-overview-body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.flow-overview-name {
  margin-top: 3px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 24px;
}
.flow-icon-radio {
  display: inline-block;
  width: 35px;
  height: 35px;
  margin: 25% 0 0 20%;
  background: url(~@/assets/attendance/radio-white.svg) no-repeat;
  -webkit-transform: scale(1.3);
  transform: scale(1.3);
}
.flow-status-icon {
  position: relative;
}
.flow-status-icon::after {
  content: "";
  position: absolute;
  right: -15px;
  bottom: -20px;
  width: 62%;
  height: 62%;
  -webkit-transform: translate(-3px, -3px) scale(1.3);
  transform: translate(-3px, -3px) scale(1.3);
}
.flow-status-icon-pass::after {
  background: url(~@/assets/attendance/circle-check-green.svg) no-repeat;
}
.flow-status-icon-processing::after {
  background: url(~@/assets/attendance/circle-line-orange.svg) no-repeat;
}
.flow-status-icon-reject::after {
  background: url(~@/assets/attendance/circle-fork-red.svg) no-repeat;
}
.flow-status-bgcolor {
  position: relative;
}
.flow-status-bgcolor::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.flow-status-bgcolor-pass::after {
  background: #47ba32;
}
.flow-status-bgcolor-processing::after {
  background: #ffa23f;
}
.flow-status-bgcolor-reject::after {
  background: #ff5c39;
}
.flow-CC .flow-overview-item {
  max-width: 4em;
  font-size: 28px;
  color: #666;
}
.cssIcon-triangle {
  display: inline-block;
  width: 15px;
  height: 15px;
}
.cssIcon-triangle--t2b {
  margin: 5px 7px;
  border-left: 1px solid #888;
  border-bottom: 1px solid #888;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.cssIcon-triangle--b2t {
  margin: 2px 7px;
  border-left: 1px solid #4196ff;
  border-bottom: 1px solid #4196ff;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
}
.approval-btn-confirm {
  width: 96px;
  line-height: 32px;
  background: #fff;
  border: 1px solid #5bbb7e;
  border-radius: 4px;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
  color: #5bbb7e;
}
.approval-btn-confirm:hover {
  background: #5bbb7e;
  border: 1px solid #5bbb7e;
  color: #fff;
}
.approval-btn-refuse {
  width: 96px;
  line-height: 32px;
  background: #fff;
  border: 1px solid #dc6e6e;
  border-radius: 4px;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
  color: #dc6e6e;
}
.approval-btn-refuse:hover {
  background: #dc6e6e;
  border: 1px solid #dc6e6e;
  color: #fff;
}
/*# sourceMappingURL=attTeacherLeave.css.map */
</style>
